<template>
  <div class="d-flex align-center">
    <v-btn icon @click="toggleBlockTeacher">
      <v-icon>{{ item.status === 'blocked' ? 'mdi-lock-open' : 'mdi-lock' }}</v-icon>
    </v-btn>
    <v-btn @click="remove" icon>
      <v-icon>mdi-delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    disabled: Boolean,
    teacher: Object,
    item: Object
  },
  methods: {
    ...mapActions('teacher', ['updateTeacher', 'removeTeacher']),
    remove() {
      this.$dialog
        .confirm({
          title: 'Xóa Giáo Viên Này',
          text: 'Xóa tài khoản sẽ xóa tương ứng toàn bộ dữ liệu liên quan đến tài khoản này. Bao gồm dữ liệu lớp học, dữ liệu điểm danh ?',
          okText: 'Xóa Giáo Viên',
          cancelText: 'Hủy',
          done: async () => {
            await this.removeTeacher(this.item)
            this.$alert.success('Xóa thành công')
          }
        })
        .bind(this)
    },
    async toggleBlockTeacher() {
      const done = async () => {
        this.item.status = this.item.status === 'blocked' ? 'active' : 'blocked'
        await this.updateTeacher(this.item)
        this.$alert.success('Cập nhật thành công')
      }

      if (this.item.status === 'blocked') {
        done()
        return
      }

      this.$dialog.confirm({
        title: 'Dừng hoạt động giáo viên',
        text: 'Giáo viên này sẽ không thể đăng nhập được nữa, bạn có chắc chắn muốn tiếp tục',
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: (() => {
          done()
        }).bind(this)
      })
    }
  }
}
</script>
